import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import type { GetAmountReq } from './mapper';
import { getAmount } from './mapper';

export const accountSettingQueryKey = createQueryKeys('setting', {
  amount: (params: GetAmountReq) => ({
    queryFn: async () => {
      const data = await getAmount(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
});

export type AccountSettingQueryKey = inferQueryKeys<typeof accountSettingQueryKey>;
